import { render, staticRenderFns } from "./stPage.vue?vue&type=template&id=108f21c6&"
import script from "./stPage.vue?vue&type=script&lang=js&"
export * from "./stPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports